// extracted by mini-css-extract-plugin
export var content = "_no-1";
export var noScroll = "_no-3";
export var paper = "_no-0";
export var scrollable = "_no-2";